/**
 * Toista lyhyt ping-ääni notifikaationa
 */
export function playNotificationSound() {
  try {
    const audioContext = new (window.AudioContext || (window as any).webkitAudioContext)();
    const oscillator = audioContext.createOscillator();
    const gainNode = audioContext.createGain();
    
    oscillator.connect(gainNode);
    gainNode.connect(audioContext.destination);
    
    oscillator.frequency.value = 800; // Hz
    oscillator.type = 'sine';
    gainNode.gain.setValueAtTime(0.3, audioContext.currentTime);
    gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.5);
    
    oscillator.start(audioContext.currentTime);
    oscillator.stop(audioContext.currentTime + 0.5);
  } catch (e) {
    console.log('Audio notification not available:', e);
  }
}

/**
 * Väräytä laitetta (mobiililaitteet)
 * @param pattern Vibraatiokuvio millisekunteina [vibrate, pause, vibrate, ...]
 */
export function vibrate(pattern: number[] = [200, 100, 200]) {
  if ('vibrate' in navigator) {
    navigator.vibrate(pattern);
  }
}

/**
 * Yhdistelmäfunktio: toista ääni ja väräytä
 */
export function notifyWithSoundAndVibration() {
  vibrate();
  playNotificationSound();
}
